/* LeParfin V18 : formulaire « Votre avis compte » (sections/lp-review-form.liquid).
   Envoi en text/plain (JSON) vers la fonction Netlify /avis, sans requête OPTIONS.
   Contrôles identiques à ceux de la fonction ; le serveur reste seul juge (ses messages s'affichent tels quels).
   Pièges à robots : champ caché « site » et délai minimal de 4 s entre l'affichage et l'envoi. */
(function () {
  'use strict';
  var MIN_MS = 4000;
  var TIMEOUT_MS = 20000;
  var RE_PRENOM, RE_VILLE;
  try {
    RE_PRENOM = new RegExp("^\\p{L}[\\p{L}\\p{M}'’ .-]*$", 'u');
    RE_VILLE = new RegExp("^[\\p{L}\\p{M}\\p{N}'’ .()-]*$", 'u');
  } catch (e) {
    RE_PRENOM = /^[A-Za-zÀ-ɏ][A-Za-zÀ-ɏ'’ .-]*$/;
    RE_VILLE = /^[A-Za-z0-9À-ɏ'’ .()-]*$/;
  }
  var RE_EMAIL = /^[^\s@"'<>(),;:\\[\]]+@[^\s@"'<>(),;:\\[\]]+\.[a-z]{2,}$/i;
  var RE_LIEN = /(https?:\/\/|www\.)/i;
  var NBSP = ' ';

  function clean(v) { return String(v || '').replace(/\s+/g, ' ').trim(); }
  function letters(v) { var m = v.match(/[A-Za-zÀ-ɏ]/g); return m ? m.length : 0; }

  function init(root) {
    if (root.dataset.lpfReady) return;
    root.dataset.lpfReady = '1';
    var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
    var form = root.querySelector('[data-lpf-form]');
    if (!form) return;
    var endpoint = (root.getAttribute('data-endpoint') || '').trim();
    var msg = {};
    try { msg = JSON.parse((root.querySelector('[data-lpf-msg]') || {}).textContent || '{}'); } catch (e) { msg = {}; }
    var alertBox = form.querySelector('[data-lpf-alert]');
    var btn = form.querySelector('[data-lpf-submit]');
    var btnLabel = form.querySelector('[data-lpf-btn-label]');
    var btnText = btnLabel ? btnLabel.textContent : '';
    var ok = root.querySelector('[data-lpf-ok]');
    var stars = form.querySelector('[data-lpf-stars]');
    var word = form.querySelector('[data-lpf-word]');
    var counter = form.querySelector('[data-lpf-count]');
    var ta = form.elements.texte;
    var tried = false;
    var busy = false;

    /* ---------- Paramètres d'adresse ---------- */
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }
    var src = params ? String(params.get('src') || '').toLowerCase() : '';
    if (src !== 'qr' && src !== 'email') src = '';
    var pre = params ? String(params.get('parfum') || '').toLowerCase() : '';
    if (pre) {
      Array.prototype.forEach.call(form.querySelectorAll('input[name="parfum"]'), function (r) {
        if (r.value === pre) r.checked = true;
      });
    }
    if ((src || pre) && window.location.hash !== '#' + root.id) {
      // Arrivée par le QR du coffret ou par un email : on va droit au formulaire.
      window.requestAnimationFrame(function () {
        try { root.scrollIntoView({ block: 'start', behavior: 'instant' }); } catch (e) { root.scrollIntoView(true); }
      });
    }

    /* ---------- Étoiles ---------- */
    var val = 0;
    var hov = 0;
    function paint() {
      if (!stars) return;
      var shown = hov || val;
      stars.setAttribute('data-v', shown ? String(shown) : '');
      stars.classList.toggle('is-hov', Boolean(hov) && hov !== val);
      if (word) {
        var r = shown ? form.querySelector('input[name="note"][value="' + shown + '"]') : null;
        word.textContent = r && r.getAttribute('data-word') ? r.getAttribute('data-word') : (word.getAttribute('data-empty') || '');
        word.classList.toggle('on', Boolean(shown));
      }
    }
    if (stars) {
      Array.prototype.forEach.call(stars.querySelectorAll('.lpf-star'), function (lab, i) {
        lab.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hov = i + 1; paint(); } });
      });
      stars.addEventListener('pointerleave', function () { hov = 0; paint(); });
    }

    /* ---------- Compteur ---------- */
    function count() {
      if (!counter || !ta) return;
      var n = ta.value.trim().length;
      counter.textContent = n + '/1' + NBSP + '000';
      counter.classList.toggle('is-low', n > 0 && n < 20);
      counter.classList.toggle('is-high', n > 1000);
    }
    if (ta) ta.addEventListener('input', count);
    count();

    /* ---------- Contrôles ---------- */
    function values() {
      var p = form.querySelector('input[name="parfum"]:checked');
      var n = form.querySelector('input[name="note"]:checked');
      return {
        parfum: p ? p.value : '',
        note: n ? parseInt(n.value, 10) : 0,
        prenom: clean(form.elements.prenom.value),
        ville: clean(form.elements.ville.value),
        texte: String(ta ? ta.value : '').replace(/\r\n?/g, '\n').trim(),
        email: String(form.elements.email.value || '').trim().toLowerCase(),
        accord: Boolean(form.elements.accord.checked),
        site: String(form.elements.site.value || ''),
      };
    }

    function validate(v) {
      var e = {};
      if (!v.parfum) e.parfum = msg.parfum;
      if (!(v.note >= 1 && v.note <= 5)) e.note = msg.note;
      if (v.prenom.length < 2 || v.prenom.length > 30 || letters(v.prenom) < 2 || !RE_PRENOM.test(v.prenom) || RE_LIEN.test(v.prenom)) e.prenom = msg.prenom;
      if (v.ville.length > 40 || !RE_VILLE.test(v.ville) || RE_LIEN.test(v.ville)) e.ville = msg.ville;
      if (v.texte.length < 20) e.texte = msg.texte_court;
      else if (v.texte.length > 1000) e.texte = msg.texte_long;
      else if (RE_LIEN.test(v.texte)) e.texte = msg.texte_lien;
      if (v.email.length > 254 || !RE_EMAIL.test(v.email)) e.email = msg.email;
      if (!v.accord) e.accord = msg.accord;
      return e;
    }

    function fieldEls(name) {
      return form.querySelectorAll('[data-lpf-field="' + name + '"]');
    }

    function showErrors(errs, focusFirst) {
      var first = null;
      ['parfum', 'note', 'prenom', 'ville', 'texte', 'email', 'accord'].forEach(function (k) {
        var box = form.querySelector('[data-lpf-err="' + k + '"]');
        var m = errs[k];
        if (box) { box.textContent = m || ''; box.hidden = !m; }
        Array.prototype.forEach.call(fieldEls(k), function (el) {
          if (el.type === 'radio') return;
          if (m) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid');
        });
        var fs = box && box.closest('fieldset');
        if (fs) fs.classList.toggle('is-err', Boolean(m));
        if (m && !first) first = fieldEls(k)[0];
      });
      if (focusFirst && first) {
        var target = first;
        if (first.type === 'radio') target = form.querySelector('input[name="' + first.name + '"]:checked') || first;
        try { target.focus({ preventScroll: false }); } catch (e) { target.focus(); }
      }
      return first;
    }

    function setAlert(text) {
      if (!alertBox) return;
      alertBox.textContent = text || '';
      alertBox.hidden = !text;
    }

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === 'note') { val = parseInt(t.value, 10) || 0; hov = 0; paint(); }
      recheck();
    });
    form.addEventListener('input', recheck);
    function recheck() {
      if (!tried) return;
      var errs = validate(values());
      showErrors(errs, false);
      if (!Object.keys(errs).length) setAlert('');
    }

    function setBusy(on) {
      busy = on;
      form.classList.toggle('is-busy', on);
      if (btn) { btn.disabled = on; btn.setAttribute('aria-busy', on ? 'true' : 'false'); }
      if (btnLabel) btnLabel.textContent = on ? (msg.sending || btnText) : btnText;
    }

    function success(text) {
      form.hidden = true;
      if (!ok) return;
      var title = ok.querySelector('[data-lpf-ok-title]');
      if (title && text && !title.textContent.trim()) title.textContent = text; // le texte du thème prime
      ok.hidden = false;
      try { ok.focus({ preventScroll: true }); } catch (e) { ok.focus(); }
      try { ok.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { ok.scrollIntoView(); }
    }

    function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (busy) return;
      tried = true;
      setAlert('');
      var v = values();
      var errs = validate(v);
      if (Object.keys(errs).length) {
        setAlert(msg.invalid);
        showErrors(errs, true);
        return;
      }
      showErrors({}, false);
      if (!endpoint) { setAlert(msg.unavailable); return; }
      setBusy(true);
      var now = (window.performance && performance.now) ? performance.now() : Date.now();
      var elapsed = now - t0;
      var pause = elapsed < MIN_MS ? MIN_MS - elapsed + 50 : 0;
      wait(pause).then(function () {
        var t1 = (window.performance && performance.now) ? performance.now() : Date.now();
        var payload = {
          parfum: v.parfum, note: v.note, prenom: v.prenom, ville: v.ville, texte: v.texte,
          email: v.email, accord: v.accord, site: v.site, ms: Math.round(t1 - t0), src: src,
        };
        var ctrl = window.AbortController ? new AbortController() : null;
        var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, TIMEOUT_MS) : null;
        return fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify(payload),
          credentials: 'omit',
          mode: 'cors',
          signal: ctrl ? ctrl.signal : undefined,
        }).then(function (res) {
          return res.json().catch(function () { return null; }).then(function (data) {
            if (timer) clearTimeout(timer);
            return { status: res.status, data: data };
          });
        });
      }).then(function (r) {
        setBusy(false);
        var d = r.data || {};
        if (r.status >= 200 && r.status < 300 && d.ok) { success(d.message); return; }
        if (d.fields && typeof d.fields === 'object') {
          setAlert(d.message || msg.invalid);
          showErrors(d.fields, true);
          return;
        }
        setAlert(d.message || msg.network);
        if (alertBox) alertBox.focus();
      }).catch(function () {
        setBusy(false);
        setAlert(msg.network);
        if (alertBox) alertBox.focus();
      });
    });
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-lpf]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
